/**
 * Generate data for a qr code that will send an SMS message
 *
 * @returns a string suitable for encoding into a QR code
 */
export const sms = (number: string, message?: string) =>
    `SMSTO:${number.replace(/[^0-9]/g, '')}${message ? `:${message}` : ''}`
